import api from './axios';

const authService = {
  login: (email, password) => {
    return api.post('/auth/login', { email, password });
  },

  registracija: (data) => {
    return api.post('/auth/registracija', data);
  },

  logout: () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    window.dispatchEvent(new Event('auth-changed'));
  },

  getProfile: () => {
    return api.get('/auth/profil');
  },

  changePassword: (currentPassword, newPassword) => {
    return api.put('/auth/sifra', { currentPassword, newPassword });
  },

  forgotPassword: (email) => {
    return api.post('/auth/forgot-password', { email });
  },

  resetPassword: (token, password) => {
    return api.post('/auth/reset-password', { token, password });
  },
};

export default authService;
